module.exports = __webpack_public_path__ + "assets/img/customerService-46a98b92.png";